export default __webpack_public_path__ + "static/media/img-mount-install.4761ddad.png";